import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a33a3e114f1f20014ab94a2_1781871273891_ef22d304/nmr/src/app/payment-management/components/PaymentManagementClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/6a33a3e114f1f20014ab94a2_1781871273891_ef22d304/nmr/src/components/AppLayout.tsx");
